function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMitsubishi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 25,
    style: {
      fill: "#e60012",
      font: "7px sans-serif"
    }
  }, "\r\n    MITSUBISHI\r\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitsubishi);
export default __webpack_public_path__ + "static/media/mitsubishi.ba092b0b649feafaba9ff9863684662b.svg";
export { ForwardRef as ReactComponent };